
import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import moment from "moment"
import { cellValuePdf, RowExportTypePdf } from "types"
import { approvalChecked, convertNumber } from "utils"
import { DataList } from "../types"

type UseExportPdf = {
  data: DataList[]
  dateFilter: string
}

export const useExportPdf = ({ data, dateFilter }: UseExportPdf) => {
  const convertType = (data: number) => {
    if (data === 1) {
      return "RECEIVED REJECTED ITEM"
    }
    if (data === 2) {
      return "RECEIVED REJECTED MONEY"
    }
    if (data === 3) {
      return "RECEIVED REJECTED ADJUSTMENT"
    }
    return "-"
  }

  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "RECEIVED REJECTED ID#", key: "trx_code", width: 25 },
    { header: "REF REJECTED ITEM ID#", key: "ref_rejected_item", width: 15 },
    { header: "REF BILL ID#", key: "ref_bill_id", width: 15 },
    { header: "DATE", key: "transaction_date", width: 15 },
    { header: "TYPE", key: "type_received", width: 15 },
    { header: "LOCATION", key: "location_name", width: 15 },
    { header: "VENDOR", key: "vendor_name", width: 15 },
    { header: "STATUS APPROVAL", key: "approve_status", width: 15 },
    { header: "QTY REJECRED", key: "qty_rejected", width: 15 },
    { header: "QTY RECEIVED", key: "qty_received", width: 15 },
    { header: "BACK REJECTED", key: "back_rejected", width: 15 },
    { header: "SUBTOTAL", key: "subtotal", width: 15 }
  ]

  function numberFormat(value: number): cellValuePdf {
    return {
      text: convertNumber(value).intoCurrency,
      style: {
        textAlign: "right",
        fontWeight: "bold"
      }
    }
  }

  const totalBalance = data.reduce((total, item) => total + Number(item?.subtotal)!, 0);

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      trx_code: item.trx_code,
      ref_rejected_item: item.ref_rejected_item,
      ref_bill_id: item.ref_bill_id,
      transaction_date: moment(item.transaction_date).format("DD/MM/YYYY"),
      type_received: item.type_received ? convertType(item.type_received) : "-",
      location_name: item.location_name,
      vendor_name: item.vendor_name,
      approve_status: item.approve_status ? approvalChecked(item.approve_status) : '-',
      qty_rejected: numberFormat(Number(item?.qty_rejected)),
      qty_received: numberFormat(Number(item?.qty_received)),
      back_rejected: numberFormat(Number(item?.qty_rejected || 0) - Number(item?.qty_received || 0)),
      subtotal: numberFormat(Number(item?.subtotal))
    }
  })

  return {
    handleExportPdf: () =>
      pdf(
        <PdfTemplate
          data={dataMap}
          column={columns}
          date={dateFilter}
          subtotal={totalBalance}
        />
      )
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = `register-received-rejected-${dateFilter}.pdf`
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column,
  date,
  subtotal
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
  date?: string
  subtotal: number
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>PURCHASE</Text>
        <Text style={styles.title}>REGISTER RECEIVED REJECTED</Text>
        {date && <Text style={styles.date}>Date: {date}</Text>}
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}>
          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY SUBTOTAL:</Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(subtotal).intoCurrency}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}
